var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('homeassist',{attrs:{"data":_vm.devices,"groupeddata":_vm.groupedData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }